import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import classNames from 'classnames'
import type * as React from 'react'
import {useMemo} from 'react'

import TransformText from '../../../containers/TransformText'
import {useDistanceToNow} from '../../../hooks/useTimeSelector'
import type {BuildTypeId} from '../../../types'
import Popup from '../Popup/Popup.lazy'

import styles from './CommentPopup.css'

type Props = {
  anchor: React.ReactElement
  actionTitle?: string
  timestamp?: string | null | undefined
  user?: string | null | undefined
  text: string | null | undefined
  className?: string
  buildTypeId?: BuildTypeId | null | undefined
  top?: number
  left?: number
  directions?: ReadonlyArray<Directions>
  lines?: number
}
const DEFAULT_POPUP_DIRECTIONS = [Directions.RIGHT_BOTTOM, Directions.LEFT_BOTTOM]
const DEFAULT_POPUP_LEFT = 3

function CommentPopup({
  anchor,
  actionTitle,
  timestamp,
  user,
  text,
  className,
  buildTypeId,
  top,
  left,
  directions,
  lines,
}: Props) {
  const classes = classNames(styles.commentPopup, className)
  const timestampFromNow = useDistanceToNow(timestamp)
  const popup = useMemo(
    () => (
      <Popup
        directions={directions || DEFAULT_POPUP_DIRECTIONS}
        left={left ?? DEFAULT_POPUP_LEFT}
        top={top}
      >
        <div className={classes}>
          {text != null && (
            <TransformText
              text={text}
              lines={lines}
              className={styles.text}
              buildTypeId={buildTypeId}
              showPlaceholder={false}
            />
          )}
          {(user != null || timestamp != null) && (
            <div className={styles.info}>
              {actionTitle != null && `${actionTitle}`}
              {user != null && ` by ${user}`}
              {timestampFromNow != null && ` ${timestampFromNow}.`}
            </div>
          )}
        </div>
      </Popup>
    ),
    [
      directions,
      left,
      top,
      classes,
      text,
      lines,
      buildTypeId,
      user,
      timestamp,
      actionTitle,
      timestampFromNow,
    ],
  )
  return (
    <Dropdown anchor={anchor} hoverHideTimeOut={300} clickMode={false} hoverMode>
      {popup}
    </Dropdown>
  )
}

export default CommentPopup
